import { createBrowserRouter, type RouteObject, Outlet } from 'react-router';
import {
    HomePage,
    ThemePreviewPage,
    CallsPage,
    CampaignsPage,
    CampaignPage,
    // AgentsPage,
    // AgentPage,
    CallPage,
    AuthPage,
    IframePage,
    StatusPage,
    GlobalPromptsPage,
} from '@/pages';
import { AppLayout, RouterErrorFallback } from '@/components/layout';
import { AuthGuard, AdminGuard } from '@/components/auth';
import { AuthProvider } from '@/context/AuthContext';
import UserSettingsProvider from '@/context/UserSettingsContext';

const AuthProviderWrapper = () => (
    <AuthProvider>
        <Outlet />
    </AuthProvider>
);

const routes: RouteObject[] = [
    {
        path: '/iframe',
        element: <IframePage />,
        errorElement: <RouterErrorFallback />,
    },
    {
        path: '/',
        element: <AuthProviderWrapper />,
        errorElement: <RouterErrorFallback />,
        children: [
            {
                path: '/',
                element: (
                    <AuthGuard>
                        <UserSettingsProvider>
                            <AppLayout />
                        </UserSettingsProvider>
                    </AuthGuard>
                ),
                children: [
                    {
                        index: true,
                        element: <HomePage />,
                    },
                    {
                        path: 'projects',
                        element: <CampaignsPage />,
                    },
                    {
                        path: 'projects/:id',
                        element: <CampaignPage />,
                    },
                    // {
                    //     path: 'agents',
                    //     element: <AgentsPage />,
                    // },
                    // {
                    //     path: 'agents/:id',
                    //     element: <AgentPage />,
                    // },
                    {
                        path: 'calls',
                        element: <CallsPage />,
                    },
                    {
                        path: 'calls/:id',
                        element: <CallPage />,
                    },
                    {
                        path: 'global-prompts',
                        element: (
                            <AdminGuard>
                                <GlobalPromptsPage />
                            </AdminGuard>
                        ),
                    },
                    {
                        path: 'theme',
                        element: <ThemePreviewPage />,
                    },
                    {
                        path: 'status',
                        element: <StatusPage />,
                    },
                ],
            },
            {
                path: '/auth',
                element: <AuthPage />,
            },
        ],
    },
];

export default createBrowserRouter(routes);
